export enum MoveToPendingModalResultEnum {
  Cancel,
  Tag,
  TagAndMoveToPending,
}
